import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component to announce route changes to screen readers
 */
const A11yAnnouncer = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    // Get page title or construct one
    const pageTitle = document.title.split('|')[0].trim() || 'New page';
    setAnnouncement(`Navigated to ${pageTitle}`);
  }, [location.pathname]);

  return (
    <div 
      className="sr-only" 
      role="status" 
      aria-live="polite" 
      aria-atomic="true"
    >
      {announcement}
    </div>
  );
};

export default A11yAnnouncer;